import IconContainer from '@/components/IconContainer'

export default function IconArrowDown(props) {
  return (
    <IconContainer
      {...props}
      width="8"
      height="11"
      ariaLabel="Arrow Down Icon"
      fill="currentColor"
    >
      <path d="M0.341633 6.50833C0.474966 6.37499 0.636078 6.31099 0.824967 6.31633C1.01386 6.3221 1.17497 6.39166 1.3083 6.52499L3.19163 8.40833L3.19163 0.974993C3.19163 0.786104 3.25563 0.62766 3.38363 0.49966C3.51119 0.372104 3.66941 0.308327 3.8583 0.308327C4.04719 0.308327 4.20563 0.372104 4.33363 0.49966C4.46119 0.62766 4.52497 0.786104 4.52497 0.974993L4.52497 8.40833L6.42497 6.50833C6.5583 6.37499 6.71674 6.30833 6.9003 6.30833C7.08341 6.30833 7.24163 6.37499 7.37497 6.50833C7.5083 6.64166 7.57497 6.8001 7.57497 6.98366C7.57497 7.16677 7.5083 7.32499 7.37497 7.45833L4.32497 10.5083C4.2583 10.575 4.18608 10.6223 4.1083 10.6503C4.03052 10.6779 3.94719 10.6917 3.8583 10.6917C3.76941 10.6917 3.68608 10.6779 3.6083 10.6503C3.53052 10.6223 3.4583 10.575 3.39163 10.5083L0.324967 7.44166C0.202744 7.31944 0.141632 7.16677 0.141632 6.98366C0.141632 6.8001 0.2083 6.64166 0.341633 6.50833Z" />
    </IconContainer>
  )
}
